"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimerBar = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const useTimer_1 = require("./useTimer");
const TimerBar = ({ duration, finishCallback, width = 450, height = 10, borderRadius = 15, color = 'black', backgroundColor = 'white', style }) => {
    const timer = (0, useTimer_1.useTimer)(duration, finishCallback);
    const timerBarContainer = {
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: backgroundColor
        }
    };
    const timerBar = (percent) => ({
        style: {
            width: `${percent}%`,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color
        }
    });
    return (
    // <div>{timer}</div>
    react_1.default.createElement(react_native_1.View, { style: [timerBarContainer.style, style] },
        react_1.default.createElement(react_native_1.View, { style: timerBar(timer / duration).style })));
};
exports.TimerBar = TimerBar;
//# sourceMappingURL=TimerBar.js.map